import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Particles from 'react-tsparticles';
import './App.css';
// import Header from './componets/Header/Header';
// import About from './pages/About/About';
// import Contact from './pages/Contact/Contact';
// import CovidTracker from './pages/CovidTracker/CovidTracker';
// import Holidayz from './pages/Holidayz/Holidayz';
import Home from './pages/Home/Home';
// import PinMatcher from './pages/PinMatcher/PinMatcher';
// import Projects from './pages/Projects/Projects';
// import WeatherTracker from './pages/WeatherTracker/WeatherTracker';
// import WildWestCars from './pages/WildWestCars/WildWestCars';

function App() {
  // const particlesInit = (main) => {
  //   console.log(main);

  //   // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
  // };

  // const particlesLoaded = (container) => {
  //   console.log(container);
  // };
  return (
    <div className="App">
      {/* <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        fpsLimit: 60,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 100,
              duration: 0.1,
              opacity: 1,
              size: 40,
            },
            push: {
              quantity: 10,
            },
            repulse: {
              distance: 150,
              duration: 0.1,
            },
          },
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          links: {
            color: "#ffffff",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 2,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              value_area: 600,
            },
            value: 50,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: "circle",
          },
          size: {
            random: true,
            value: 5,
          },
        },
        detectRetina: true,
      }}
    />  */}
      <BrowserRouter>
        {/* <Header /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<Home />} />
          <Route path="/projects" element={<Home />} />
          <Route path="/contact" element={<Home />} />
          {/* <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} /> */}
          {/* <Route path="/project/wild-west-cars" element={<WildWestCars />} />
          <Route path="/project/covid-tracker" element={<CovidTracker />} />
          <Route path="/project/Holidayz" element={<Holidayz />} />
          <Route path="/project/weather-tracker" element={<WeatherTracker />} />
          <Route path="/project/pin-matcher" element={<PinMatcher />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
